import React from 'react';
import { ArrowRight } from 'lucide-react';
const COVER_URL = 'https://cdn.magicpatterns.com/uploads/mxhHXRmrKE17QFZqnjyvyS/pasted-image.png';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5yJUmvh9YcA85AWox7xXA1/logo_neurolecturas.png';
export function Hero() {
  return <section className="relative min-h-screen w-full bg-[#1a56a0] flex flex-col items-center justify-center overflow-hidden px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-119">
      {/* Top Nav / Logo Bar */}
      <div className="hero-fade-down absolute top-0 left-0 w-full z-20 px-4 sm:px-6 lg:px-8 pt-5" data-id="element-120">
        <div className="max-w-6xl mx-auto flex items-center" data-id="element-121">
          <img src={LOGO_URL} alt="NeuroLecturas Pro logo" className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover flex-shrink-0" width={40} height={40} data-id="element-122" />
          <span className="ml-2.5 font-sans font-semibold text-white text-sm sm:text-base tracking-wide" data-id="element-123">
            NeuroLecturas Pro
          </span>
        </div>
      </div>

      {/* Background geometric accents */}
      <div className="absolute top-0 left-0 w-full h-2 bg-[#c0392b]" data-id="element-124" />
      <div className="absolute bottom-0 right-0 w-1/3 h-1 bg-[#c0392b]" data-id="element-125" />
      <div className="absolute top-1/4 left-0 w-24 h-1 bg-white opacity-20" data-id="element-126" />

      {/* Two-column layout */}
      <div className="relative z-10 max-w-6xl w-full mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16" data-id="element-127">
        {/* Left: Text content */}
        <div className="flex-1 text-center lg:text-left" data-id="element-128">
          {/* Main Headline */}
          <h1 className="font-serif font-black text-white leading-[0.9] tracking-tight" data-id="element-129">
            <div className="hero-slide-up text-[clamp(2.2rem,8vw,7rem)] block" data-id="element-130">
              No vivas con miedo,
            </div>
            <div className="hero-slide-up hero-delay-200 text-[clamp(2.2rem,8vw,7rem)] block" data-id="element-131">
              <span className="inline-block bg-white text-[#c0392b] px-4 py-1 shadow-lg -rotate-1" data-id="element-132">
                vive con un plan.
              </span>
            </div>
          </h1>

          {/* Subtitle */}
          <p className="hero-fade-in hero-delay-800 mt-6 text-base sm:text-lg md:text-xl text-white/80 font-sans font-light max-w-xl mx-auto lg:mx-0 leading-relaxed" data-id="element-133">
            El Manual de Defensa para familias latinas + 8 Imprimibles prácticos
            para actuar en segundos.
          </p>
        </div>

        {/* Right: Book Cover + CTA */}
        <div className="hero-slide-in-right hero-delay-600 flex-shrink-0 w-full max-w-[300px] sm:max-w-[340px] lg:max-w-[400px]" data-id="element-134">
          <div className="relative" data-id="element-135">
            {/* Urgency Banner - positioned on the book cover */}
            <div className="hero-pop-in hero-delay-900 absolute -top-3 -right-3 z-20 bg-[#c0392b] px-5 py-1.5 shadow-lg rotate-3" data-id="element-136">
              <span className="text-white font-bold text-[1.05rem] tracking-widest uppercase font-sans" data-id="element-137">
                ACTUALIZADO 2026
              </span>
            </div>

            {/* White frame around the book cover */}
            <div className="relative bg-white p-2 sm:p-3 shadow-2xl" data-id="element-138">
              <img src={COVER_URL} alt="Portada del ebook Invisibles pero Invencibles — Manual de Defensa para Latinos Sin Miedo" className="relative w-full h-auto block" loading="eager" width={400} height={520} data-id="element-139" />
            </div>
            {/* Subtle book spine effect */}
            <div className="absolute top-0 left-0 w-[3px] h-full bg-gradient-to-b from-white/20 via-white/5 to-white/20 rounded-l-sm" data-id="element-140" />
          </div>

          {/* CTA Button — below the book cover */}
          <div className="hero-fade-in hero-delay-1200 mt-8 text-center" data-id="element-141">
            <a href="#pricing" className="cta-pulse cta-shimmer group relative inline-flex items-center justify-center px-8 py-5 bg-[#c0392b] text-white font-bold uppercase tracking-widest text-base sm:text-lg hover:bg-[#e74c3c] hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#c0392b] focus:ring-offset-[#1a56a0] w-full overflow-hidden rounded-md" data-id="element-142">
              <span data-id="element-143">🛡️ DESCARGAR MI GUÍA Y BONOS AHORA</span>
              <ArrowRight className="ml-3 w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-144" />
            </a>
            <p className="mt-4 text-sm text-white/60 font-sans" data-id="element-145">
              Disponible inmediatamente en formato digital PDF
            </p>
          </div>
        </div>
      </div>

      {/* Decorative scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center opacity-50 animate-bounce" data-id="element-146">
        <div className="w-[1px] h-12 bg-white/30 mb-2" data-id="element-147" />
        <span className="text-xs tracking-widest uppercase text-white/50" data-id="element-148">
          Descubre Más
        </span>
      </div>
    </section>;
}